var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('el-card',{staticClass:"el-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("胤之旅客服后台")])]),_c('div',[_c('LoginCore',{ref:"aLoginCore"})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }